<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Название"
          :type="{'is-danger': errors.has('name')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('name', 'required')
          }]">
          <b-input
            name="name"
            placeholder="Название"
            icon="user"
            v-validate="'required'"
            v-model="model.name">
          </b-input>
        </b-field>
        <b-field label="Состояние">
          <b-select
            placeholder="Выбирете тип"
            name="is_active"
            expanded
            v-model="model.is_active">
            <option
              v-for="option in state"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <b-field grouped group-multiline>
          <template v-for="item in has_perms">
            <div v-if="item.selected" v-bind:key="item.id" class="control">
              <b-tag type="is-primary" closable @close="remPerms(item.id)">{{item.value}}</b-tag>
            </div>
          </template>
        </b-field>
        <template>
          <b-field label="Поиск полномочий">
            <b-autocomplete
                :data="data"
                placeholder="Введите название, действие или значение полномочия"
                field="perms_name"
                v-model="search"
                :loading="isFetching"
                @typing="getAsyncData"
                @select="option => addPerms(option)">

                <template slot-scope="props">
                  <div class="media">
                    <div class="media-content">
                      {{ props.option.value }}
                      <br>
                      <small>
                        {{ props.option.description}}
                      </small>
                    </div>
                  </div>
                </template>
            </b-autocomplete>
          </b-field>
        </template>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>

import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'
import debounce from 'lodash/debounce'

export default {
  name: 'RoleForm',
  components: {
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    const state = [
      {
        id: true,
        name: "Активная роль"
      },
      {
        id: false,
        name: "Не активная роль"
      }
    ]
    const has_perms = []
    const data = []
    return {
      data: data,
      state: state,
      has_perms: has_perms,
      isFetching: false,
      search: "",
      model: {
        id: undefined,
        name: '',
        is_active: false
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getRole', $this.id)
        .then(response => {
          let data = response.data.data;
          // $this.model = data
          for(let propertyName in data) {
            if(propertyName != "perms"){
              $this.model[propertyName] = data[propertyName]
            }
            else{
              if (data[propertyName].length) {
                data[propertyName].forEach(function(item){
                  item.selected = true
                  $this.has_perms.push(item)
                })
              }
            }
          }
        })
        .catch(error => {
          this.model = this.purge_model
        })
    }

  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    addPerms(option){
      let check = this.has_perms.filter(function(item){
        return item.id == option.id
      })

      if(!check.length){
        let new_perms = Object.assign({}, option)
        new_perms.selected = true
        this.has_perms.push(new_perms)
      }
    },
    remPerms(id){
      let $this = this
      $this.has_perms.forEach(function(item){
        if(item.id === id){
          item.selected = false
        }
      })
    },
    getPermsForRole(){
      return this.has_perms.filter(function(item){
        return item.selected == true
      }).map(function(item){
        return item.id
      })
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        let payload = this.model
        payload.permissions = this.getPermsForRole()

        $this.$store.dispatch('updateRole', $this.model)
      }
      else{
        let payload = this.model
        payload.permissions = this.getPermsForRole()
        $this.$store.dispatch('createRole', $this.model)
      }
    },
    
    getAsyncData: debounce(function () {
      if (!this.search.length) {
          this.data = []
          return
      }

      this.isFetching = true
      
      this.$store.dispatch('searchPermission', this.search)
      
      .then(response => {
        let data = response.data.data;
        if (data.length){
          this.data = []
          data.forEach((item) => this.data.push(item))
        }
        else{
          this.data = []
        }
      })
      .catch(error => {
        this.data = []
      })

      this.isFetching = false

    }, 500),  
  }
}
</script>

<style scoped>
</style>
<style>
</style>